export default {
  props: ['fullscreen'],
  data() {
    return {
      isFavorite: false,
      isDisabled: false,
    };
  },
  computed: {
    hasLimit() {
      return !!this.bulkPrice;
    },
    showFavoritePhoto() {
      return this.$store.getters.SHOW_FAVORITE_PHOTO;
    },
    disabledNextButton() {
      return ['3-digital-more-photos', '3-default-more-photos'].includes(
          this.orderStep) && this.balance;
    },
    showNextButton() {
      let show = false;

      if (this.products && this.products.length > 0) {
        show = [
          '1',
          '3-digital-more-photos',
          '3-default-more-photos',
          '4'].includes(`${this.orderStep}`);
      }

      if (this.orderStep === 1 && !!+this.photo.not_for_sale) {
        show = false;
      }

      return show;
    },
    carouselView() {
      return this.$store.getters.CAROUSEL_VIEW;
    },
  },
  watch: {
    photo(photo) {
      if (photo) {
        this.markFavorite(photo.id);
      }
    },
    favorites(favorites) {
      if (favorites) {
        this.markFavorite(this.photo.id);
      }
    },
  },
  methods: {
    async handleFavorite() {
      this.isFavorite = !this.isFavorite;

      this.isDisabled = true;
      if (this.isFavorite) {
        await this.$store.dispatch('ADD_FAVORITE', {
          albumId: this.album.id,
          albumTitle: this.album.title !== null ? this.album.title : this.$t(
              'no_name'),
          albumStatus: this.album.status,
          albumHash: this.album.hash,
          albumHashPassword: this.album.hash_password,
          tag: this.$store.getters.ALBUM_TAG,
          photoId: this.photo.id,
          photoPath: this.photo.medium_photo,
          freeDownload: this.photo.free_download ? +this.photo.free_download : 0,
        });
      } else {
        await this.$store.dispatch('DELETE_FAVORITE',
            {albumId: this.album.id, photoId: this.photo.id});
      }
      this.isDisabled = false;
    },
    markFavorite(id) {
      if (this.album && this.album.id) {
        const album = this._.find(this.favorites, {albumId: this.album.id});

        if (album) {
          this.isFavorite = !!this._.find(album.items, {photoId: id});
        }
      }
    },
    selectAll() {
      let photos = this.albumPhotos.filter(photo => !+photo.not_for_sale);

      if (this.product.isDownloadable) {
        photos = photos.filter(photo => +photo.free_download);
      }

      if (this.productItem.limitTo > 0) {
        photos = photos.slice(0, this.productItem.limitTo);
      }

      this.$store.dispatch('SET_PHOTOS', photos);
    },
    deselectAll() {
      this.$store.dispatch('SET_PHOTOS', [
          this._.first(this.myOrder.photos)
      ]);
    },
    next() {
      this.$store.dispatch('ADD_PREV_ORDER_STEP', this.orderStep);
      this.$emit('handle-fullscreen', false);

      if (this.orderStep === 1) {
        this.$store.dispatch('INIT_ORDER');
        this.$store.dispatch('ADD_PHOTO', this.photo);
        this.$router.push(
            this.i18nLink(`album/gallery/${this.getAlbumId()}/order`));
      }

      if (this.orderStep === 4) {
        /*if (this.myOrder.productItem.variants && this.myOrder.productItem.variants.length > 0) {
          const variant = this._.find(this.myOrder.productItem.variants, {id: this.myOrder.productVariantId});
          const bulkPrices = variant.pricelist_product_variants.length > 0 ? this._.first(variant.pricelist_product_variants).bulk_prices : [];

          let bulkPrice = null;

          if (bulkPrices.length > 0) {
            // eslint-disable-next-line no-console
            console.log(this._.sortBy(bulkPrices, 'quantity').reverse());
            this._.sortBy(bulkPrices, 'quantity').reverse().forEach((item) => {
              if (this.myOrder.quantity >= +item.quantity) {
                bulkPrice = item;
              }
            });
          }

          this.$store.dispatch('SET_BULK_PRICE', bulkPrice ? bulkPrice : null);
        }*/

        this.toast(null,
            this.$tc('n_photos_added_to_cart', this.myOrder.quantity, {amount: this.myOrder.quantity}),
            'success');

        this.$store.dispatch('ADD_TO_CART');
        this.$store.dispatch('DROP_ORDER');

        this.$router.push(this.i18nLink('cart'));
      } else if (['3-default-confirm', '3-digital-confirm'].includes(
          this.orderStep)) {
        if (this.myOrder.productItem.variants.length === 1) {
          const variant = this._.first(this.myOrder.productItem.variants);
          const item = this.myOrder.productItem;

          item.price = parseFloat(variant.price);

          this.$store.dispatch('SET_BULK_PRICE', null);
          this.$store.dispatch('SET_PRODUCT_ITEM', this.myOrder.productItem);
          this.$store.dispatch('SET_PRODUCT_VARIANT_ID', variant.id);

          if (variant.pricelist_product_variants.length > 0) {
            this.$store.dispatch('SET_PRICELIST_PRODUCT_ID',
                this._.first(variant.pricelist_product_variants).id);
          }
        }

        this.$store.dispatch('SET_ORDER_STEP', `${this._.first(
            this.orderStep.split('-'))}-${this.product.slug}-${this.myOrder.productItem.variants.length > 1
              ? 'variants'
              : this._.first(this._.first(this.myOrder.productItem.variants).pricelist_product_variants).bulk_prices.length > 0
                  ? 'bulk-prices'
                  : 'more-photos'}`);
      } else if (['3-default-bulk-prices', '3-digital-bulk-prices'].includes(
          this.orderStep)) {
        let nextStep = `${this._.first(
            this.orderStep.split('-'))}-${this.product.slug}-more-photos`;
        this.$store.dispatch('SET_BULK_PRICE', null);
        this.$store.dispatch('SET_ORDER_STEP', nextStep);
      } else {
        if (!this.disabledNextButton) {
          this.$store.dispatch('SET_ORDER_STEP', parseInt(this.orderStep) + 1);
        } else {
          this.showLimitNotification();
        }
      }
    },
    back() {
      this.$emit('handle-fullscreen', false);

      if (`${this.orderStep}` === '1') {
        this.closeOrder();
      } else {
        if (`${this.orderStep}` === '2') {
          if (this.mass) {
            this.closeOrder();
          } else {
            this.$router.push(this.i18nLink(
                `album/gallery/${this.getAlbumId()}/order/${this.photo.id}`));

            this.$store.dispatch('SET_ORDER_STEP', this.lastPrevStep);
            this.$store.dispatch('REMOVE_LAST_PREV_ORDER_STEP');
          }
        } else {
          this.$store.dispatch('SET_ORDER_STEP', this.lastPrevStep);
          this.$store.dispatch('REMOVE_LAST_PREV_ORDER_STEP');
        }
      }
    },
    showLimitNotification() {
      if (this.disabledNextButton && !document.querySelector('.toast')) {
        this.toast(null,
            this.$tc(`messages.select_another_n_photos${this.bulkPrice ? '_bulk' : ''}`, this.balance,
                {amount: this.balance}), 'info');
      }
    },
  },
  created() {
    if (this.album && this.photo) {
      this.markFavorite(this.photo.id);
    }
  },
};
